import React, { useReducer, startTransition } from "react";
import moment from "moment";
import CryptoJS from "crypto-js";
import i18next from "i18next";
import { config } from "../../config/index";
import { getSSOAuthToken } from "../../helpers/sso";

import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { LOGIN, LOGOUT, SET_USER, SET_USER_TYPE } from "./actions";
import AppContext from "./contexts";
import AppReducer from "./reducers";

const { API_URL } = config;

const initialState = {
  // isLoggedIn: (localStorage.getItem("token") && (localStorage.getItem("loginDate") < localStorage.getItem("expiryDate")))
  //     ? true
  //     : false,
  isLoggedIn: localStorage.getItem("token") ? true : false,
  isLoading: false,
  type: localStorage.getItem("type") ? localStorage.getItem("type") : false,
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : false,
};

const AppStore = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  const loginHandler = async (type, email, password, event) => {
    event.preventDefault();

    let url = `${API_URL}/${type}/login`;

    try {
      let response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ email, password }),
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });

      let data = await response.json();

      // Handle API errors
      if (!response.ok) {
        ToastUtil.error(data.message || "Login failed");
        return;
      }

      // Success
      const { client } = data.user.site_associates[0].site;

      let loginDate = moment().valueOf();
      localStorage.setItem("loginDate", loginDate);

      data.token && localStorage.setItem("token", data.token);
      data.type && localStorage.setItem("type", data.type);
      data.type && dispatch({ type: SET_USER_TYPE, payload: data.type });

      data.user && localStorage.setItem("user", JSON.stringify(data.user));
      data.user && dispatch({ type: SET_USER, payload: data.user });

      data.type && data.user && dispatch({ type: LOGIN });

      startTransition(() => {
        i18next.changeLanguage(data.user.language);
      });
    } catch (error) {
      // Only network/server errors reach here
      ToastUtil.error("Server error. Please try again later.");
    }
  };

  const logoutHandler = () => {
    // localStorage.getItem("token") && localStorage.clear()
    localStorage.clear();
    dispatch({ type: LOGOUT });
  };

  return (
    <AppContext.Provider
      value={{
        isLoggedIn: state.isLoggedIn,
        isLoading: state.isLoading,
        loginHandler,
        logoutHandler,
        user: state.user,
        type: state.type,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppStore;
